import React, { useState, useEffect } from "react";  // Importing useState and useEffect
import { Container, Row, Col, Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import MetaManager from "../MetaManager";
import OtherServicesCarousel from "../OtherServicesCarousel";
import CallToAction from "../Home/CallToAction/CallToAction";
import BannerForm from './BannerForm';
import Faq from "./Faq";
import './Services.css';
const PrintingofFabricBackdrops = () => {

    const servicesFaqData = [
        { 
            question: "What customisation options are available for fabric backdrop printing?", 
            answer: "Printingy offers a range of customisation options for custom fabric backdrop printing, including sizes, materials, and finishes. You can add logos, graphics, and vibrant colour schemes tailored to your branding needs. Our personalised printing for fabric backdrop ensures your designs stand out with clarity and precision."
        },
        { 
            question: "Does Printingy handle bulk orders for fabric backdrops and cloth banners?", 
            answer: "Yes, Printingy specialises in bulk Fabric Backdrop Printing and Cloth Banner Printing. Bulk orders ensure consistent quality and cost-effective solutions, making it ideal for large events, exhibitions, and marketing campaigns. We guarantee reliable production and on-time delivery for all large-scale orders."
        },
        { 
            question: "What industries benefit from fabric backdrop printing services?", 
            answer: "Fabric backdrops are widely used in events, photography, retail, and hospitality industries. Businesses rely on the Printing of Fabric Backdrops for stage backdrops, promotional banners, and exhibition displays, while photographers use custom-printed backdrops for studio shoots. Printingy tailors solutions to suit the unique requirements of these industries."
        },
        { 
            question: "What materials are used for fabric backdrops and cloth banners?", 
            answer: "We use high-quality, wrinkle-resistant materials for Cloth Banner Printing and backdrops, including polyester and other durable fabrics. These materials are lightweight, easy to transport, and suitable for indoor and outdoor use. Custom finishes, such as matte or glossy, ensure vibrant visuals and professional appeal."
        },
        { 
            question: "Does Printingy provide design assistance for custom fabric backdrops?", 
            answer: "Yes, our custom fabric backdrop printing services include professional design assistance. Whether you need help finalising your concept or creating a new design, our expert team collaborates to ensure your backdrop reflects your vision. From colour matching to graphic placement, we ensure precision and quality."
        },
        { 
            question: "What is the typical turnaround time for fabric backdrop printing?", 
            answer: "Turnaround times for Printing Fabric Backdrops depend on the size and complexity of the order. Standard bulk orders are typically completed within a few business days. For highly customised designs or larger volumes, we provide clear timelines and prioritise meeting your deadlines without compromising quality."
        },
        { 
            question: "Are eco-friendly options available for fabric backdrops?", 
            answer: "Printingy is committed to sustainability and offers eco-friendly options for Fabric Backdrop Printing. We use recyclable materials and non-toxic inks to minimise environmental impact, ensuring your backdrops align with environmentally conscious branding efforts."
        },
        { 
            question: "What factors should I consider when ordering fabric backdrops?", 
            answer: "Consider the size, purpose, and placement when ordering custom-printed backdrops. Selecting high-quality materials, professional designs, and the right finish ensures your backdrops are effective, durable, and visually appealing. Printingy’s team provides guidance throughout the process to help you achieve the desired results."
        },
        { 
            question: "How do I place an order for fabric backdrop printing?", 
            answer: "Placing an order is simple and efficient. Visit our website and select your preferences for Fabric Backdrop Printing, including sizes and designs. Upload your design files or share your requirements, and our team will assist you throughout the process. We ensure a seamless experience from design approval to delivery."
        },
        { 
            question: "What makes bulk fabric backdrop printing cost-effective?", 
            answer: "Bulk custom fabric backdrop printing reduces per-unit costs, making it ideal for large-scale events and campaigns. By consolidating production and materials, Printingy delivers exceptional quality at competitive prices. Our bulk printing solutions provide excellent value without compromising on professional standards."
        }
    ];
    
    
    const [pageTitle, setPageTitle] = useState('Printing of Fabric Backdrops');  // Dynamic title state

    useEffect(() => {
      document.title = pageTitle; // Set the document title dynamically
    }, [pageTitle]); // This will run whenever the pageTitle changes
    

  return (
    <div>
    <MetaManager 
  title="Custom Fabric Backdrop Printing Services for Events"
  description="Professional printing of fabric backdrops and cloth banners. Bulk custom fabric backdrop printing with personalised printing solutions for events and branding."
  keywords="Printing of Fabric Backdrops,
Fabric Backdrop Printing,
Cloth Banner Printing,
Custom fabric backdrop printing,
Custom printed backdrop,
Personalised printing for fabric backdrop

"
/>


      <header className="services-header text-center py-5 serviceheader">
        <Container>
          <Row className="align-item-cen">
            <Col lg={6}>
              <h1>Professional Printing of Fabric Backdrops</h1>
              <h2 className="text-muted">
              Custom fabric backdrop printing for events, branding, and promotions
              </h2>
            </Col>

            {/* Contact Form on the Right Side */}
            <Col lg={6}>
              <div className="contact-form p-4 bg-white shadow-sm rounded" style={{ maxWidth: "400px", margin: "auto" }}>
                <h3 className="text-center mb-4">Get in Touch</h3>
                <BannerForm />
              </div>
            </Col>
          </Row>
        </Container>
      </header>

      <section className="services-overview ">
        <Container>
          <p>
          Fabric backdrops are essential for creating impactful visual displays for events, exhibitions, photo shoots, or branding campaigns. Printingy specialises in Printing Fabric Backdrops and custom fabric backdrop printing, offering vibrant, durable, and high-quality solutions tailored to your needs.
          </p>
          <p>Our services include Cloth Banner Printing and personalised printing for fabric backdrops, ensuring your designs align with your brand’s identity. Whether you need banners for trade shows, stage backdrops, or retail displays, our advanced printing technology guarantees professional results with sharp graphics and vibrant colours.
</p>
          <p>With bulk printing options and customisation flexibility, Printingy delivers reliable and cost-effective solutions for all your backdrop and banner needs. Trust us to make your visual displays stand out.
          </p>
        </Container>
      </section>

      <section className="why-choose py-5">
        <Container>
          <h2 className="text-center mb-4">Why Choose Printingy</h2>

          {/* Custom Flyer Printing Experts */}
          <div className="py-4 px-3  rounded mb-4">
            <Row className="al-center">
              <Col lg={6}>
              <h2 className="small-hed">Reliable and Custom Fabric Backdrop Printing</h2>
                <h3 className="large-hed">High-quality, vibrant, and durable fabric backdrops and banners </h3>

                <ul className="list-unstyled">
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Expert Fabric Backdrop Printing for events, photo shoots, and promotions.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Bulk custom fabric backdrop printing for cost-effective solutions.

                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Professional Cloth Banner Printing for sharp, vibrant visuals.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Durable and wrinkle-free materials for easy handling and reuse.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Advanced technology for crisp details and colour consistency.

                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Personalised designs tailored to your branding needs.

                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Quick turnarounds and efficient order management systems.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Trusted by event organisers, retailers, and branding agencies nationwide.

                  </li>
                </ul>
                <Button variant="primary" className="mt-3">
                  Contact Us
                </Button>
              </Col>

              {/* Contact Form on the Right Side */}
              <Col lg={6}>
                <img
                  src="/assets/img/fabricbackdrop.jpg" // Path relative to the public folder
                  alt="Printing of Fabric Backdrops for events"
                  className="img-fluid rounded"
                />
              </Col>
            </Row>
          </div>
          <CallToAction 
      title="Connect with us Today"
        description="Your trusted Partner for Bulk Printing Solutions..!"
      />
          {/* Professional Flyer Printing with Precision */}
          <div className="shadow-sm p-4 rounded">
            <h2 className="large-hed">Premium Fabric Backdrops Delivered On Time</h2>
            <h3 className="small-hed">Focus on your event while we manage your backdrop printing needs</h3>
            <p>At Printingy, we combine advanced technology and high-quality materials to deliver professional custom-printed backdrops and Cloth Banner Printing solutions. Whether for stage events, retail displays, or photo backdrops, we ensure precision and consistency in every print.</p>
            <p>Our streamlined processes guarantee timely delivery for bulk orders, ensuring your Fabric Backdrop Printing is ready when needed. Partner with Printingy for reliable and impactful fabric backdrops that enhance your event or promotional displays.</p>
          </div>
        </Container>
      </section>



      <div>
  {/* Existing Content */}
  <OtherServicesCarousel />
  {/* Other Content */}
</div>

<Faq faqData={servicesFaqData} />
   
    </div>
  );
};

export default PrintingofFabricBackdrops;
